import React, { useEffect } from 'react';

import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import Router from './pages/router';
import { createGlobalStyle } from 'styled-components';
import { store } from './store';
import { ConfigProvider, App } from 'antd';
import { useTranslation } from 'react-i18next';
import ar_EG from 'antd/locale/ar_EG';
import en_US from 'antd/locale/en_US';

const GlobalStyle = createGlobalStyle`
html{
    min-height:100%;
    position:relative;
}
body{
    height:100%;
    min-height: 100vh;
}
:root {
   --primary-color: ${({ colorPrimary }) => colorPrimary};
}
`;
const Main = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const queryParameters = new URLSearchParams(window.location.search);
    const urlLang = queryParameters.get('lang');
    if (urlLang === 'en' || urlLang === 'ar') {
      i18n.changeLanguage(urlLang);
    }
  }, [i18n]);
  let locale;
  switch (i18n.resolvedLanguage) {
    case 'en':
      locale = en_US;
      break;
    case 'ar':
      locale = ar_EG;
      break;
    default:
      locale = en_US;
      break;
  }
  const colorPrimary = '#022366';
  return (
    <Provider store={store}>
      <ConfigProvider
        locale={locale}
        theme={{
          token: {
            colorPrimary,
            colorBgMask: '#022366a8',
          },
          components: {
            Switch: {
              colorPrimary: '#1AAE9F',
              colorPrimaryHover: '#1AAE9F',
            },
          },
        }}
      >
        <App>
          <BrowserRouter>
            <GlobalStyle colorPrimary={colorPrimary} />
            <Router />
          </BrowserRouter>
        </App>
      </ConfigProvider>
    </Provider>
  );
};

export default Main;
